import { BaseNomenclature } from "./baseNomenclature.model";

export class Practice extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="practice";
    }
}